/**
 * Created by Jonas Wålekvist on 2017-12-11.
 */

import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {Translation} from "@nolimitcity/slot-game/bin/core/translation/Translation";
import {
    IStillImageBgIntroViewConfig,
    StillImageBgIntroView
} from "@nolimitcity/slot-game/bin/game/intro/StillImageBgIntroView";
import {FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {DragonTribeGameAssets} from "../DragonTribeGameAssets";
import {IBoxConfig, SpritePageFlipper} from "./pageFlipper/SpritePageFlipper";
import {DragonTribe} from "../DragonTribe";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";

export class DragonTribeIntroView extends StillImageBgIntroView {

    private readonly _winUpTo: string = "win more than";
    private readonly _bet: string = "bet";
    private _board: PIXI.Sprite;
    private _pageFlipView: SpritePageFlipper;
    private _pageBoxConfig: IBoxConfig [] = [];

    private _logo: PIXI.Sprite;
    private _gfxContainer: PIXI.Container;
    private readonly _pageTextStyle: any = {
        fill: 0xff6c00,
        fontFamily: "LuckiestGuy",
        fontSize: 24,
        wordWrap: true,
        wordWrapWidth: 200,
        fontWeight: FontWeight.BOLD
    };
    private readonly _winUpToTextStyle: any = {
        fill: 0xff0000,
        fontFamily: "Open Sans",
        wordWrap: true,
        wordWrapWidth: 200,
        fontWeight: FontWeight.BOLD,
        fontSize: 12
    };

    constructor(config: IStillImageBgIntroViewConfig) {
        super(config);
    }

    startPresentation(data?: ParsedServerData, onShowComplete?: () => void): void {
        super.startPresentation(data, onShowComplete);

        this._pageFlipView.startSlideShow(7);
    }

    protected createGameGraphics(): PIXI.DisplayObject {
        this._gfxContainer = new PIXI.Container();

        this._board = new PIXI.Sprite(GameResources.getTextures("introBg")[0]);
        this._board.anchor.set(0.5, 0);
        if (DragonTribe.api.gameClientConfiguration.isSet) {
            if (DragonTribe.api.gameClientConfiguration.showLowProbabilityGfx) {
                this.addWinUpToText(this._board);
            }
            this.hideXNudgeContent();
            this.createPageFlipper();
        } else {
            DragonTribe.api.events.once(APIEvent.GAME_CLIENT_CONFIGURATION_APPLIED, () => {
                if (DragonTribe.api.gameClientConfiguration.showLowProbabilityGfx) {
                    this.addWinUpToText(this._board);
                }
                this.hideXNudgeContent();
                this.createPageFlipper();
            });
        }

        this._logo = new PIXI.Sprite(GameResources.getTextures(DragonTribeGameAssets.INTRO_LOGO)[0]);
        this._logo.anchor.set(0.5, 0);

        this._gfxContainer.addChild(this._board);
        this._gfxContainer.addChild(this._logo);
        return this._gfxContainer;
    }

    private createPageFlipper(): void {
        // pageFlipper
        const arrowLeft: PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("btnLeft")[0]);
        const arrowRight: PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("btnRight")[0]);

        this._pageFlipView = new SpritePageFlipper(
            arrowLeft,
            arrowRight,
            this._pageBoxConfig
        );
        this._pageFlipView.forceInitAnimations();
        this._pageFlipView.interactEnabled = true;
        this._gfxContainer.addChild(this._pageFlipView);
        this._pageFlipView.slideShowEnabled = true;
    }

    private hideXNudgeContent(): void {
        this._pageBoxConfig = [
            {
                infoSprite: new PIXI.Sprite(!DragonTribe.api.gameClientConfiguration.showLowProbabilityGfx ? GameResources.getTextures("introPage0_US")[0] : GameResources.getTextures("introPage0")[0]),
                title: "xNUDGE WILD",
                text: !DragonTribe.api.gameClientConfiguration.showLowProbabilityGfx ? "" : Translation.translate("Each xNudge Wild drop increases multiplier up to x6!")
            },
            {
                title: "xWAYS MYSTERY SYMBOL",
                infoSprite: new PIXI.Sprite(GameResources.getTextures("introPage2")[0]),
                text: Translation.translate("The xWays Mystery Symbol can hold 2-3 symbols inside and will expand the reels!")
            },
            {
                title: "DRAGON SPINS",
                infoSprite: new PIXI.Sprite(GameResources.getTextures("introPage1")[0]),
                text: Translation.translate("Choose between two bonus modes - Dragon Spins or Dragon Spins Extreme.")
            },
            {
                title: "DRAGON WILD",
                infoSprite: new PIXI.Sprite(GameResources.getTextures("introPage3")[0]),
                text: Translation.translate("Every third winning cascade in Dragon Spins will turn one of the five dragons into Wild and award +2 spins.")
            }
        ];
    }

    private addWinUpToText(page: PIXI.Sprite): void {
        const posY: number = 100;
        const posX: number = 183;
        const page1WinUpTo: PIXI.Text = new PIXI.Text(Translation.translate(this._winUpTo), this._winUpToTextStyle);
        page1WinUpTo.anchor.set(0.5);
        page1WinUpTo.position.y = posY;
        page1WinUpTo.position.x = posX;
        page.addChild(page1WinUpTo);
        const page1TimesBet: PIXI.Text = new PIXI.Text("26 000x", this._pageTextStyle);
        page1TimesBet.anchor.set(0);
        page1TimesBet.position.y = posY + 10;
        page.addChild(page1TimesBet);
        const page1Bet: PIXI.Text = new PIXI.Text(Translation.translate(this._bet), this._winUpToTextStyle);
        page1Bet.anchor.set(0);
        page1Bet.position.y = posY + 20;
        const textLength: number = page1Bet.width + page1TimesBet.width;
        page1TimesBet.position.x = posX - textLength / 2 - 10;
        page1Bet.position.x = posX - textLength / 2 + page1TimesBet.width;
        page.addChild(page1Bet);
    }

    protected onResizeGameGraphics(resizeData: IResizeData): void {
        if (resizeData.orientation == Orientation.PORTRAIT) {
            const isIPad: boolean = resizeData.width / resizeData.height >= 0.76;
            let offset: number = isIPad ? 70 : 0;
            this._board.scale.set(1.65, 1.65);
            this._board.position.set(0, 24);

            this._logo.scale.set(1.65, 1.65);
            this._logo.position.set(0, -160);

            this._pageFlipView.scale.set(1.85, 1.85);
            this._pageFlipView.position.set(-319, /*featureY*/ 12);

            this._gfxContainer.position.set(this._screenWidth / 2, this._screenHeight * 0.27 - offset);
        } else {
            this._board.scale.set(1, 1);
            this._board.position.set(0, -30);

            this._pageFlipView.scale.set(1.2, 1.2);
            this._pageFlipView.position.set(-195, /*featureY*/ -65);

            this._logo.scale.set(0.7, 0.7);
            this._logo.position.set(0, -80);

            this._gfxContainer.position.set(this._screenWidth / 2, this._screenHeight * 0.1);
        }

        this._pageFlipView.onResize(resizeData);

    }
}
